import { ModuleFE_PertinentCategory } from './ModuleFE_PertinentCategory.js';
export const ModulePackFE_PertinentCategoryDB = [ModuleFE_PertinentCategory];
//# sourceMappingURL=module-pack.js.map